import { render, staticRenderFns } from "./MemoryConflict.vue?vue&type=template&id=df2e803e&scoped=true&"
import script from "./MemoryConflict.vue?vue&type=script&lang=js&"
export * from "./MemoryConflict.vue?vue&type=script&lang=js&"
import style0 from "./MemoryConflict.vue?vue&type=style&index=0&id=df2e803e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2e803e",
  null
  
)

export default component.exports